<template>
    <div class="addTicket">
        <el-card shadow="never">
            <el-row>
                <el-col :span="9">
                    <el-form 
                    :model="ruleForm" 
                    :rules="rules" 
                    ref="ruleForm"
                    label-width="100px"
                    class="demo-ruleForm"
                    >   
                        <el-form-item label="销售地点" prop="locationCode">
                            <el-col :span="22">
                                <el-select v-model="value9" filterable placeholder="试一试搜索:销售地点" clearable  @change="handleChange2" :loading="loading" size = "large">
                                    <el-option
                                        v-for="item in options2"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value"
                                    >
                                    </el-option>
                                </el-select>
                            </el-col>
                        </el-form-item>
                        <el-form-item label="类型" prop="typeCode">
                            <el-select v-model="value" placeholder="请选择类型"  @change="handleChange3" clearable>
                                <el-option
                                    v-for="item in options"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"
                                    :loading="loading"
                                    >
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="库存数量" prop="quanTity" >
                            <el-col :span="15">
                                <el-input v-model="ruleForm.quanTity" placeholder="" :disabled="true"></el-input>
                            </el-col>
                        </el-form-item> 
                        <el-form-item label="调整数量" prop="adjustQuantity" >
                            <el-col :span="15">
                                <el-input v-model="ruleForm.adjustQuantity" placeholder="请输入调整数量" maxlength="7"></el-input>
                            </el-col>
                        </el-form-item>
                        <el-form-item label="调整后数量" prop="totalQuanTity" >
                            <el-col :span="15">
                                <el-input v-model="ruleForm.totalQuanTity" placeholder="" :disabled="true"></el-input>
                            </el-col>
                        </el-form-item>   
                        <el-form-item>
                            <el-button type="primary" @click="submitForm('ruleForm')">确认</el-button>
                            <el-button @click="cancel">返回</el-button>
                        </el-form-item>
                    </el-form>
                </el-col>
            </el-row>
        </el-card>
    </div>
</template>
<style lang="less">
    .line{
        text-align: center;
    }
</style>
<script>
import requestMixin from '../../mixins/request';
import common from '../../mixins/common';
import axios from '../../env/axios';
import apis from '../../env/apis' ;
export default {
    mixins:[requestMixin,common],
    inject:['reload'],
    data(){
        var validatorQty = (rule,value,callback) => {
            let {quanTity,totalQuanTity} = this.ruleForm ;
            totalQuanTity = Number(quanTity)+Number(value) ;
            if(Number(value) == 0){
                callback(new Error('调整数量不能为0'))
            }
            if(totalQuanTity < 0){
                callback(new Error("调整数量不能大于库存数量"));
            }else if(totalQuanTity.toString() == 'NaN'){
                callback(new Error('请输入数字'))
            }else{
                this.ruleForm.totalQuanTity = totalQuanTity ;
                callback();
            }
        }
        return {
            ruleForm:{
                typeCode:'',
                type : '',
                locationCode:'',
                complimentary:'',
                quanTity : '',
                adjustQuantity : '',
                totalQuanTity : ''
            },
            rules:{
                typeCode:[
                    { required: true, message: '请选择类型编号', trigger:'blur'}
                ],
                locationCode: [
                    { required: true, message: '请选择地点名称', trigger: 'blur' },
                ],
                quanTity: [
                    { required: true, message: '库存数量加载失败', trigger: 'blur' },
                ],
                adjustQuantity:[
                    {validator : validatorQty , required : true ,trigger: 'change'},
                    { min: 1, max: 7, message: '长度在 1 到 7 个数字', trigger: 'blur' }
                ]
            },
            value9:'',
            options2:[
                {
                    value : '', 
                    label : ''
                }
            ],
            value: '',
            options:[
                {
                    value : '', 
                    label : ''
                }
            ],
            selectData:'',
            errData:[],
            loading: false,
        }
    },
    created (){
       
    },
    mounted(){
        this.loadingArea();
        this.loadType()
    },
    methods:{
        _alert(title){
            this.$alert(title, '提示', {
                confirmButtonText: '确定',
                type: 'warning',
                center: true,
            });
        },
        //保存券号信息
        submitForm(formName) {   
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let {locationCode,typeCode,adjustQuantity ,quanTity} = this.ruleForm ;
                    let userId = sessionStorage.getItem("userId") ;
                    let params = {
                        act : 'repertoryAdd',
                        locationCode,
                        typeCode,
                        add : adjustQuantity,
                        inventory : quanTity,
                        userId
                    }
                    let loading = this.loadingCommon();
                    this.delType(params).then(res => {
                        let { status } = res.data;
                        if( status == true){
                            loading.close();
                            this.promptMsg('调整成功','success');
                            
                            this.reload();
                        }else if(status == false){
                            loading.close();
                            this._alert('数据异常请刷新!')
                            this.reload();
                        }else{
                            loading.close();
                            this._alert('调整失败')
                        }
                    }).catch((error) => {
                        loading.close();
                    })
                } else {
                    return false;
                }
            });
        },
        //点击取消，跳转到上一页
        cancel(){
            this.$router.go(-1)
        },
        //店铺选择
        loadingArea(){
            let userId = sessionStorage.getItem("userId") ;
            let params = {
                act:'findLocations',
                userId
            }
            this.findType(params).then( (res) => {
                console.log(res)
                let {status,list} = res.data;
                this.loading = true;
                if(status == true){
                    this.loading = false;
                    this.selectData = list;
                    this.options2 = list.map( (elem) => {
                        return { value : elem.locationCode ,label:elem.description }
                    })
                }
            })
        },
        /**
         * 销售地点change
         */
        handleChange2(value){
            this.ruleForm.locationCode = value;
            let selectData = this.selectData ;
            let userId = sessionStorage.getItem("userId") ;
            let { locationCode ,typeCode} = this.ruleForm ;
            // selectData.forEach((elem) =>{
            //     if(elem.locationCode == value){
            //         this.ruleForm.complimentary = elem.complimentary;
            //         if(this.ruleForm.complimentary == 'Y'){
            //              this.ruleForm.complimentary = '是'
            //         }else{
            //             this.ruleForm.complimentary = '否'
            //         }
            //     }
            // }); 
            if(locationCode && typeCode){
                  console.log(this.ruleForm)
                let params = {
                    act : 'repertory',
                    locationCode,
                    typeCode,
                    userId
                }
                this.getRepertory(params);
            }
        },
        //查找类型
        loadType(){
            let userId = sessionStorage.getItem("userId") ;
            let params = {
                act : 'findTypes',
                userId
            }
            this.findType(params).then((res) => {
                this.loading = true;
                let {status} = res.data ;
                if(status == true){
                    this.loading = false;
                    let {list} = res.data;
                    this.options = list.map(elem => {
                        return {value : elem.typeCode ,label :elem.description}
                    }) ;
                }
            })
        },
        handleChange3(val){
            this.value = val ;
            this.ruleForm.typeCode = val ;
            let { locationCode ,typeCode} = this.ruleForm ;
            let userId = sessionStorage.getItem("userId") ;
            if(locationCode && typeCode){
                let params = {
                    act : 'repertory',
                    locationCode,
                    typeCode,
                    userId
                }
                this.getRepertory(params);
            }
        },
        //加载库存数量
        getRepertory(params){
            let that = this ;
            that.delType(params).then((res) => {
                let { status } = res.data ;
                if(status == true){
                    that.ruleForm.quanTity = '加载中'
                    let { report } = res.data ;
                    if(report.length == 0){
                        that.ruleForm.quanTity = 0 ;
                    }else{
                        that.ruleForm.quanTity = report[0].onhandQuantity;
                    }
                }else{
                    this._alert('库存数量加载失败')
                }
            })
        }
    }
}
</script>
